module.exports = __webpack_public_path__ + "img/bike.ac96530e.svg";